module.exports = __webpack_public_path__ + "static/media/backWave15.2df183ac.svg";